const common = {
  // Nav
  nav_home: 'Home',
  nav_books: 'Books',
  nav_courses: 'Courses',
  nav_mentorship: 'Mentoria SÍLEX',
  nav_webinars: 'Webinars',
  nav_about: 'About',
  nav_contact: 'Contact',
  nav_links: 'Links',
  nav_enter: 'Sign In',
  nav_my_courses: 'My Courses',
  nav_community: 'Community',
  nav_ranking: 'Ranking',
  nav_certificates: 'Certificates',
  // Auth
  auth_login_title: 'Access your account',
  auth_login_subtitle: 'Sign in with email or social networks',
  auth_register_title: 'Create your account',
  auth_register_subtitle: 'Sign up to access the courses',
  auth_forgot_title: 'Recover password',
  auth_forgot_subtitle: 'We will send a link to your email',
  auth_tab_login: 'Sign In',
  auth_tab_register: 'Create Account',
  auth_email: 'Email',
  auth_password: 'Password',
  auth_name: 'Full name',
  auth_confirm_password: 'Confirm password',
  auth_forgot_link: 'Forgot my password',
  auth_btn_login: 'Sign In with Email',
  auth_btn_register: 'Create Free Account',
  auth_btn_forgot: 'Send Recovery Link',
  auth_or: 'or continue with',
  auth_or_register: 'or sign up with',
  auth_google: 'Continue with Google',
  auth_facebook: 'Continue with Facebook',
  auth_apple: 'Continue with Apple',
  auth_back_login: '← Back to login',
  auth_terms: 'By signing in, you agree to our',
  auth_terms_link: 'Terms of Use',
  auth_privacy_link: 'Privacy Policy',
  auth_and: 'and',
  // Livros page
  livros_hero_badge: 'Complete Library',
  livros_hero_title: 'Books & Ebooks',
  livros_hero_subtitle: 'Knowledge that transforms. Choose your next book and start your journey of growth.',
  livros_filter_all: 'All',
  livros_filter_pdf: 'E-book PDF',
  livros_filter_print: 'Print',
  livros_search_placeholder: 'Search book or topic...',
  livros_btn_buy: 'Buy Now',
  livros_btn_amazon: 'Amazon',
  livros_btn_details: 'See Details',
  livros_pages: 'pages',
  livros_readers: 'readers',
  livros_cta_title: 'Want access to all books?',
  livros_cta_subtitle: 'Subscribe to SB Family and get unlimited access to the full library + courses + group mentorship.',
  livros_cta_btn: 'Explore Subscription',
  livros_stat_books: 'Published Books',
  livros_stat_readers: 'Satisfied Readers',
  livros_stat_rating: 'Average Rating',
  livros_stat_editions: 'Revised Editions',
  // Language
  lang_label: 'Language',
  lang_pt: 'Português',
  lang_es: 'Español',
  lang_en: 'English',
  lang_fr: 'Français',
  lang_de: 'Deutsch',
  lang_it: 'Italiano',
  lang_ja: 'Japanese',
};

export default common;
